import { render } from "./TugasPokok.vue?vue&type=template&id=06f34da6"
import script from "./TugasPokok.vue?vue&type=script&lang=js"
export * from "./TugasPokok.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__